exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".GalleryViewer-3f4348f9{text-align:center}.singleImg-802a0f7e{text-align:center}.singleImg-802a0f7e img{max-width:100%;max-height:675px;margin:0 auto}.singleImgBig-c5337a2f{text-align:center;height:80vh;max-height:600px;overflow:hidden;display:flex;justify-content:center;align-items:center;position:relative}.singleImgBig-c5337a2f img{width:100%;height:auto;margin:0 0;flex:0 0 100%}.caption-47c461a0{text-align:center;font-style:italic;color:#666}@media screen and (max-width: 500px){.singleImg-802a0f7e img{max-height:400px}.singleImgBig-c5337a2f{max-height:400px}}\n", ""]);

// Exports
exports.locals = {
	"GalleryViewer": "GalleryViewer-3f4348f9",
	"singleImg": "singleImg-802a0f7e",
	"singleImgBig": "singleImgBig-c5337a2f",
	"caption": "caption-47c461a0"
};